// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/

const E = module.exports;

E.routes = {
    index: [
        {path: '/auth*', template: 'light'},
        {path: '/unverified_email'},
        {path: '/unverified_email_resend'},
        {path: '/verified_email'},
        {path: '/error_bot'},
        {path: '/error_bot_cap'},
        {path: '/error_country'},
        {path: '/error_email'},
        {path: '/error_ip'},
        {path: '/reset_password'},
        {path: '/no_req_reset_password'},
    ],
    cp: [
        {path: '/onboarding'},
        {path: '/dashboard'},
        {path: '/reports*'},
        {path: '/apps*'},
        {path: '/reviews*'},
        {path: '/partners*'},
        {path: '/billing*'},
        {path: '/tiers'},
        {path: '/docs*'},
        {path: '/bundles*'},
        {path: '/checklists*'},
        {path: '/notifications*'},
        {path: '/tools*'},
        {path: '/settings*'},
        {path: '/users*'},
        {path: '/urls*', template: 'light'},
        {path: '/forgot_password'},
        {path: '/forgot_password_success'},
        {path: '/restricted', template: 'light'},
        {path: '/referrals*'},
    ],
};
